import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpModule } from '@angular/http';
/**
 * Locale Registration
 */
import { registerLocaleData } from '@angular/common';
import { default as localeEn } from '@angular/common/locales/en';

import { RestService } from './services/rest.service';
import { PagerService } from './services/pager.service';
import { AuthService as AngularxAuthSerive } from 'angularx-social-login';
import { AuthServiceConfig } from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';
import { environment } from '../environments/environment.prod';
import { WidgetsComponentsModule } from './components/widgets/widgets-components.module';
import { AmToasterModule } from '@angularminds/am-toaster';
import { AppLoaderModule } from './app-loader.module';
import { AppLoaderService } from './services/app-loader.service';
import { SocketService } from './services/socket.service';

const config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(environment.google.oAuth.clientId),
  },
]);

export function provideConfig() {
  return config;
}

const LOCALE_PROVIDERS = [
  { provide: LOCALE_ID, useValue: 'en' },
  AngularxAuthSerive,
  {
    provide: AuthServiceConfig,
    useFactory: provideConfig,
  },
];
registerLocaleData(localeEn, 'en');

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    AmToasterModule,
    AppLoaderModule,

    /**
     * Nprogress Modules
     */
    // NgProgressModule.withConfig({
    //   thick: true,
    //   spinner: false,
    //   color: '#0190fe',
    // }),
    // NgProgressRouterModule,
    // NgProgressHttpModule,

    /**
     * Routing Module
     */
    AppRoutingModule,
    WidgetsComponentsModule,
  ],
  providers: [AppLoaderService, ...LOCALE_PROVIDERS, RestService, PagerService, SocketService],
  // providers: [RestService],
  bootstrap: [AppComponent],
})
export class AppModule {}
